// Provides CASL ability context based on authenticated user
import { createContext, useContext, useMemo } from 'react';
import { buildAbilityFromUser } from './ability';
import { useAuthStore } from '@stores/auth.store';

const AbilityContext = createContext(null);

// Default ability when used outside provider (e.g. HMR or duplicate module) so hooks never throw
const emptyAbility = buildAbilityFromUser(null);

const AbilityProvider = ({ children }) => {
    const user = useAuthStore((state) => state.user);
    const ability = useMemo(() => buildAbilityFromUser(user), [user]);

    return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>;
};

export default AbilityProvider;
export const useAbility = () => useContext(AbilityContext) ?? emptyAbility;
